<template>
    <rkm-area
        no-margin-top
        title="Odontograma"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="auto">
                <Item
                    :get-value="() => item.saudeBucal.odontograma.possuiAparelho ? 'Sim' : 'Não'"
                    label="Possui aparelho"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <Item
                    :get-value="() => item.saudeBucal.odontograma.possuiAparelho ? 'Sim' : 'Não'"
                    label="Possui contenção"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <Item
                    :get-value="() => item.saudeBucal.odontograma.protesesTotais.join(', ')"
                    label="Prótese"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Dentes"
                >
                    <rkm-row>
                        <rkm-col cols="auto">
                            <rkm-form-radio-group
                                label="Mostrar dentes decíduos"
                                v-model="item.saudeBucal.odontograma.mostrarDentesDeciduos"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <BoxDente :item="item" />
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-area
            no-margin-top
            title="Histórico de evoluções"
        >
            <rkm-list
                :items="item.saudeBucal.odontograma.procedimentos"
                hide-filters
                hide-pagination
                item-cursor="default"
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col cols="2">
                            <Item
                                :get-value="() => item.local"
                                label="Local"
                            />
                        </rkm-col>

                        <rkm-col cols="10">
                            <strong>Procedimentos</strong><br />

                            <div
                                v-for="(procedimento, index) in item.procedimentos"
                                :key="index"
                            >
                                {{procedimento.descricao}}, <strong>Quantidade: </strong>{{procedimento.quantidade}}
                            </div>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <Item
                                :get-value="() => item.observacao"
                                label="Observações"
                            />
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>
    </rkm-area>
</template>

<script>
// Components.
import BoxDente from './components/dente/Index'
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {
        BoxDente,
        Item
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>